// extracted by mini-css-extract-plugin
module.exports = {"map":"_3Dij0fwLDB","widget":"_3FgQ5bnCeP","click":"_2eYDJiN0Xn","container":"_15C1uHpwF-"};
    if(module.hot) {
      // 1614934746705
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  